module.exports = __webpack_public_path__ + "assets/PackIcon.3c83cbf3dd3857b80545c4d560b660b6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/svg/packs/PackIcon.svg
// module id = 867
// module chunks = 0